import ResellerPage from './ResellerPage';

export default ResellerPage;
